interface FormRealTimeScoresProps {
  scores: { title: string; value: number }[];
}

export const FormRealTimeScores = ({ scores }: FormRealTimeScoresProps) => (
  <div className="flex flex-wrap gap-3">
    {scores.map((score) => (
      <div
        key={score.title}
        className="flex flex-col items-center gap-1 min-w-[120px] rounded-lg border bg-muted/30 px-3.5 py-2.5"
      >
        <span className="text-xs font-medium text-center leading-tight text-muted-foreground">{score.title}</span>
        <span className="text-lg font-bold text-primary">{score.value}</span>
      </div>
    ))}
  </div>
);
